import Sticky from './Sticky'

export default Sticky



// WEBPACK FOOTER //
// ./src/components/Sticky/index.js